import {Product} from 'components/customer/Product/entity/Product';
import {RANGEHOOD} from 'components/customer/Product/store/productApi';

const parseApplianceFileId = (fileId: unknown): number | null => {
    if (typeof fileId === 'number' && fileId > 0) {
        return fileId;
    }

    if (typeof fileId === 'string' && fileId.trim() !== '') {
        const parsed = Number(fileId);
        if (Number.isInteger(parsed) && parsed > 0) {
            return parsed;
        }
    }

    return null;
};

export const mapAppliance = (
    product: Product
): {
    product: Product;
    formData: FormData | null;
} => {
    let formData: FormData | null = null;

    if ('appliance' in product) {
        const applianceRow: NonNullable<Product['job_cabinet_appliances']>[0] =
            {
                appliance_type: 'rangehood',
                custom: product.appliance?.custom ? 1 : 0,
                make: product.appliance?.make ?? '',
                model: product.appliance?.model ?? '',
                external_code: product.appliance?.externalCode ?? '',
                spec_file_name: product.appliance?.specFilename ?? '',
                id: product.appliance?.id ?? null,
            };

        const specPath = product.appliance?.specPath;
        const isExplicitSpecRemoval = specPath === null || specPath === '';
        const isSpecFile = specPath instanceof File;

        if (isExplicitSpecRemoval) {
            applianceRow.spec_file_path = '';
            applianceRow.file_id = null;
        } else {
            if (typeof specPath === 'string' && specPath !== '') {
                applianceRow.spec_file_path = specPath;
            }

            const fileId = parseApplianceFileId(product.appliance?.fileId);
            if (fileId !== null && !isSpecFile) {
                applianceRow.file_id = fileId;
            }
        }

        product.job_cabinet_appliances = [applianceRow];

        if (isSpecFile) {
            formData = new FormData();
            formData.append('appliance_spec[0]', specPath);
            formData.append('product', JSON.stringify(product));
        }
    }

    return {product, formData};
};

export const mapJobCabinetAppliances = (product: Product): Product => {
    if (
        product.job_cabinet_appliances &&
        product.job_cabinet_appliances?.length > 0
    ) {
        const jobCabinetAppliance = product.job_cabinet_appliances[0];

        product.appliance = {
            type: RANGEHOOD,
            custom: jobCabinetAppliance.custom == 1,
            make: jobCabinetAppliance.make,
            model: jobCabinetAppliance.model,
            externalCode: jobCabinetAppliance.external_code,
            specFilename: jobCabinetAppliance.spec_file_name,
            specPath: jobCabinetAppliance.spec_file_path,
            fileId: jobCabinetAppliance.file_id,
            height: jobCabinetAppliance.height,
            id: jobCabinetAppliance.id,
        };
    }

    return product;
};
